import { render, staticRenderFns } from "./restaurantAttendance2.vue?vue&type=template&id=615982bf&scoped=true&"
import script from "./restaurantAttendance2.vue?vue&type=script&lang=js&"
export * from "./restaurantAttendance2.vue?vue&type=script&lang=js&"
import style0 from "./restaurantAttendance2.vue?vue&type=style&index=0&id=615982bf&prod&lang=scss&"
import style1 from "./restaurantAttendance2.vue?vue&type=style&index=1&id=615982bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615982bf",
  null
  
)

export default component.exports